/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import * as fromUserData from '../actions/user-data.action';

export interface UserDataState {
  userData: any;
  errorMessage: string;
  success: boolean;
  failed: boolean;
  loading: boolean;
}

export const initialState = {
  userData: {},
  errorMessage: '',
  success: false,
  failed: false,
  loading: false,
};

export function reducer(state = initialState, action: fromUserData.UserDataAction): UserDataState {
  switch (action.type) {
    case fromUserData.USER_LOGIN:
    case fromUserData.GET_USER_BY_ID:
    case fromUserData.GET_USER_BY_TOKEN: {
      return {
        ...state,
        userData: {},
        loading: true,
        success: false,
        failed: false,
      };
    }

    case fromUserData.REFRESH_USER_DATA:
    case fromUserData.USER_LOGOUT:
    case fromUserData.UPDATE_USER_DATA: {
      return {
        ...state,
        loading: true,
        success: false,
        failed: false,
      };
    }

    case fromUserData.USER_LOGIN_SUCCESS:
    case fromUserData.REFRESH_USER_DATA_SUCCESS:
    case fromUserData.UPDATE_USER_DATA_SUCCESS:
    case fromUserData.GET_USER_BY_ID_SUCCESS:
    case fromUserData.GET_USER_BY_TOKEN_SUCCESS: {
      return {
        ...state,
        userData: action.payload,
        loading: false,
        success: true,
      };
    }

    case fromUserData.REFRESH_USER_DATA_FAIL:
    case fromUserData.UPDATE_USER_DATA_FAIL:
    case fromUserData.USER_LOGIN_FAIL:
    case fromUserData.GET_USER_BY_ID_FAIL:
    case fromUserData.GET_USER_BY_TOKEN_FAIL: {
      return {
        ...state,
        errorMessage: action.payload,
        loading: false,
        failed: true,
      };
    }

    case fromUserData.USER_LOGOUT_SUCCESS: {
      return {
        ...state,
        userData: {},
        loading: false,
        success: false,
      };
    }

    case fromUserData.USER_LOGOUT_FAIL: {
      return {
        ...state,
        loading: false,
        failed: true,
      };
    }
  }
  return state;
}

export const getUserData = (state: UserDataState) => state.userData;
export const getUserDataLoading = (state: UserDataState) => state.loading;
export const getUserDataSuccess = (state: UserDataState) => state.success;
export const getUserDataFail = (state: UserDataState) => ({ failed: state.failed, message: state.errorMessage });
